import { render } from "./BaseCheckbox.vue?vue&type=template&id=429d52a9&scoped=true&ts=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=429d52a9&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429d52a9"]])

export default __exports__